
import MediaUploadForm
from "../forms/MediaUploadForm";

export default function UploadMediaDialog({

    open,

    onClose,

    onSuccess

}){
    if(!open){

        return null;

    }

    return(

        <div className="dialog-overlay">

            <div className="dialog">

                <div className="dialog-header">

                    <div>

                        <h2>

                            Upload Media

                        </h2>

                        <p>

                            Choose a file and organize it before uploading.

                        </p>

                    </div>

                    <button

                        className="dialog-close"

                        onClick={onClose}

                    >

                        ✕

                    </button>

                </div>

                <div className="dialog-body">

                    <MediaUploadForm

                        onSuccess={onSuccess}

                        onCancel={onClose}

                    />

                </div>

            </div>
<style>{`.dialog-overlay{

    position:fixed;

    inset:0;top:0px;

    background:rgba(15,23,42,.45);

    display:flex;

    align-items:center;

    justify-content:center;

    z-index:99999;

    padding:24px;

}

.dialog{

    width:100%;
 
    max-width:720px;

    background:#FFF;

    border-radius:20px;

    overflow:hidden;

    box-shadow:0 30px 80px rgba(15,23,42,.25);

    animation:dialogIn .2s ease;

}

@keyframes dialogIn{

    from{

        opacity:0;

        transform:translateY(15px);

    }

    to{

        opacity:1;

        transform:none;

    }

}

.dialog-header{

    display:flex;

    justify-content:space-between;

    align-items:flex-start;

    padding:28px;

    border-bottom:1px solid #EEF2F7;

}

.dialog-header h2{

    margin:0;

    font-size:26px;

}

.dialog-header p{

    margin-top:8px;

    color:#6B7280;

}

.dialog-body{

    padding:28px;

}

.dialog-close{

    width:40px;

    height:40px;

    border:none;

    background:#F3F4F6;

    border-radius:10px;

    cursor:pointer;

    font-size:16px;

    transition:.2s;

}

.dialog-close:hover{

    background:#E5E7EB;

}`}</style>
        </div>

    );

}